<template lang="pug">
    .concurs(ref="concurs")
        Intro(:class="{show: screen==='intro'}")
        Icebreaker(:class="{show: screen==='icebreaker'}" @goToIntro="screen='intro'")
</template>

<script>
    import Intro from '@/components/concurs/Intro'
    import Icebreaker from '@/components/concurs/Icebreaker'
    import {mapState} from 'vuex';

    export default {
        name: "Concurs",
        data: () => ({
            screen: 'intro',
            canScroll: true,
            offsetY: 0, //for mobile touchmove
        }),
        computed: {
            ...mapState(['isMobileDevice', 'popup'])
        },
        watch: {
            screen(screen) {
                this.$store.state.whiteHeader = screen === 'intro'
            }
        },
        methods: {
            preventWheel(e) {
                if (!this.canScroll) return;
                if (this.popup !== null) return
                this.canScroll = false;
                let delta = e.deltaY;

                // scroll down
                if (delta > 0) {
                    this.screen = 'icebreaker';
                } else if (delta < 0) {
                    this.screen = 'intro';
                }
                setTimeout(() => {
                    this.canScroll = true
                }, 700);
            },
            touchStart(e){
                this.offsetY = typeof e.touches !== 'undefined' ? e.touches[0].clientY : e.offsetY;
            },
            touchMove(e){
                let offsetY = typeof e.touches !== 'undefined' ? e.touches[0].clientY : e.offsetY;
                if (this.offsetY > offsetY){
                    this.screen = 'icebreaker';
                }
            },
            touchEnd(){
                this.offsetY = 0;
            }

        },
        beforeMount() {
            this.$store.state.whiteHeader = true;
        },
        mounted() {
            if (!this.isMobileDevice) {
                this.$refs.concurs.addEventListener('wheel', this.preventWheel);
            }else{
                this.$refs.concurs.addEventListener('touchstart', this.touchStart);
                this.$refs.concurs.addEventListener('touchmove', this.touchMove);
                this.$refs.concurs.addEventListener('touchend', this.touchEnd);
            }
        },
        beforeDestroy() {
            if (!this.isMobileDevice) {
                this.$refs.concurs.removeEventListener('wheel', this.preventWheel)
            }else{
                this.$refs.concurs.removeEventListener('touchstart', this.touchStart);
                this.$refs.concurs.removeEventListener('touchmove', this.touchMove);
                this.$refs.concurs.removeEventListener('touchend', this.touchEnd);
            }
        },
        components: {
            Intro,
            Icebreaker,
        },
    }
</script>

<style lang="scss">
    @import "@/assets/scss/_functions.scss";
    @import "@/assets/scss/_variables.scss";
    @import "@/assets/scss/_mixins.scss";

    .concurs_intro, .concurs_icebreaker {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        will-change: transform;
        transition: transform 0s .7s;

        &.show {
            transform: translateY(0);
            transition: transform .7s ease-in-out;
            z-index: 5;
        }
    }
    .concurs_intro {
        transform: translate3d(0, -100%, 0);
    }

    .concurs_icebreaker {
        transform: translate3d(0, 100%, 0);
    }
</style>
